type SessionState = {
  hasUnsavedDraft: boolean;
  setHasUnsavedDraft: (value: boolean) => void;
};

let hasUnsavedDraft = false;

function setHasUnsavedDraft(value: boolean) {
  hasUnsavedDraft = value;
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", (event) => {
    if (hasUnsavedDraft) {
      event.preventDefault();
    }
  });
}

export function useSessionStore<T>(selector: (state: SessionState) => T) {
  return selector({ hasUnsavedDraft, setHasUnsavedDraft });
}
